
interface Country {
    code: string;
    name: string;
}

const CountryDefaults: Country = {
    code: null,
    name: null,
}

interface Countries extends Array<Country> {
}

const CountriesDefaults: Countries = [];


export {
    Country,
    CountryDefaults,
    Countries,
    CountriesDefaults
}